import { useParams } from 'react-router-dom';
import { useGetSkillResource } from '@/hooks';
import { ENTRYPOINT_FILE_ID, ENTRYPOINT_FILE_NAME } from '@/pages/skills/Editor/constants';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { SkillFileCrumbProps } from './types';

const SkillFileCrumb = ({ skillParam, fileParam, isCurrentPage = false }: SkillFileCrumbProps) => {
    const params = useParams();
    const skillId = params[skillParam];
    const fileId = params[fileParam];
    const isEntrypoint = fileId === ENTRYPOINT_FILE_ID;

    const { resource, isLoadingResource } = useGetSkillResource({
        skillId: skillId || '',
        resourceId: fileId || '',
        enabled: Boolean(skillId) && Boolean(fileId) && !isEntrypoint,
    });

    const label = isEntrypoint
        ? ENTRYPOINT_FILE_NAME
        : isLoadingResource
          ? '...'
          : resource?.name || `Reference ${fileId?.slice(0, 8)}...`;

    return (
        <EntityBreadcrumb
            label={label}
            entityId={fileId || ''}
            entityType="File"
            isCurrentPage={isCurrentPage}
            isLoading={!isEntrypoint && isLoadingResource}
        />
    );
};

export default SkillFileCrumb;
